const text = `
# Mediální partneři:
`
const sponsors = [
  {
    name: 'Únia materských centier',
    logo: require('../resources/sponsors/uniamc.png'),
    link: 'http://www.materskecentra.sk/',
  },
  {
    name: 'kidmania',
    logo: require('../resources/sponsors/kidmania.png'),
    link: 'https://www.kidmania.sk/',
  },
  {
    name: 'play atelier',
    logo: require('../resources/sponsors/playatelier.jpg'),
    link: 'http://playatelier.eu/',
  },
  {
    name: 'kamsdetmi.sk',
    logo: require('../resources/sponsors/kamsdetmi.jpg'),
    link: 'http://kamsdetmi.sk/',
  },
  {
    name: 'Strom života',
    logo: require('../resources/sponsors/stromzivota.png'),
    link: 'http://stromzivota.sk/',
  },
  {
    name: 'Eduma',
    logo: require('../resources/sponsors/eduma.jpg'),
    link: 'http://eduma.sk/',
  },
  {
    name: 'Těhotenství, porod a miminko',
    logo: require('../resources/sponsors/modrykonik.png'),
    link: 'https://www.modrykonik.cz/',
  },
  {
    name: 'biobaby.sk',
    logo: require('../resources/sponsors/biobaby.png'),
    link: 'http://www.biobaby.sk/',
  },
  {
    name: 'perinbaba.sk',
    logo: require('../resources/sponsors/perimbaba.png'),
    link: 'http://www.perinbaba.sk',
  },
  {
    name: 'Čo jedia zdravé deti',
    logo: require('../resources/sponsors/zdravedeti.jpg'),
    link: 'http://www.cojediazdravedeti.sk',
  },
  {
    name: 'Centrum pro Rodinu a Sociální Péči',
    logo: require('../resources/sponsors/crsp.png'),
    link: 'http://crsp.cz/',
  },
  {
    name: 'Rádio VIVA',
    logo: require('../resources/sponsors/radio-viva.png'),
    link: 'http://www.radioviva.sk/',
  },
  {
    name: 'Iuventa',
    logo: require('../resources/sponsors/iuventa.png'),
    link: 'https://www.iuventa.sk/',
  },
  {
    name: 'chicmama',
    logo: require('../resources/sponsors/chicmama.png'),
    link: 'http://www.chicmama.sk/',
  },
  {
    name: 'Čo dokáže mama',
    logo: require('../resources/sponsors/co-dokaze-mama.png'),
    link: 'http://www.codokazemama.sk/',
  },
  {
    name: 'Dobrá škola',
    logo: require('../resources/sponsors/dobraskola.jpg'),
    link: 'http://www.dobraskola.com/',
  },
  {
    name: 'Naše děti Brno',
    logo: require('../resources/sponsors/nesedeti.jpg'),
    link: 'http://nase-deti-brno.cz/',
  },
  {
    name: 'Pipiqi',
    logo: require('../resources/sponsors/piqipi.png'),
    link: 'https://piqipi.sk/',
  },
]

export default {
  text,
  sponsors,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/sponsors/medialPartners.js